import script from "./CheckBox.vue?vue&type=script&lang=ts&setup=true"
export * from "./CheckBox.vue?vue&type=script&lang=ts&setup=true"

import "./CheckBox.vue?vue&type=style&index=0&id=e9bbf1ca&scoped=true&lang=css"

import exportComponent from "/data/jenkins/workspace/jet/cbt/production/deploy-cbt/exam/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e9bbf1ca"]])

export default __exports__